import { axios, IDynamicObject } from "xa-generics";
import { AccessModel } from "../Models/Access.model";
import { AXIOSNAMES } from "../../../Static/AxiosInstanceNames.static";
import { HostModel } from "../Models/Host.model";

export abstract class AccessDAO {
    public static async loadServer(id: string): Promise<HostModel> {
        const request = await axios
            .getInstance(AXIOSNAMES.ONEMIN)
            .get<IDynamicObject>(`/api/v3/restaurants/${id}/server`);
        const model = new HostModel(request.data);
        axios.getInstance(AXIOSNAMES.PRINT).defaults.baseURL = model.host;
        return model;
    }

    /**
     * The header name has to match the one the interceptor sets from the cookie, capital A and all
     * (see index.tsx). Spelled any other way both end up on the request, and a header set twice is
     * joined with a comma - "Bearer x, Bearer x" is not a token anybody can read, so the request
     * comes back 401.
     *
     * It is still passed explicitly: a token redeemed from a handoff arrives here before it is in
     * the cookie, and the interceptor only fills the header in when it finds one there.
     */
    public static async loadMe(token?: string): Promise<AccessModel> {
        const request = await axios.getInstance().get<IDynamicObject<any>>(
            `/api/admins/me`,
            token
                ? {
                      headers: {
                          Authorization: token
                      }
                  }
                : undefined
        );
        return new AccessModel(request.data);
    }

    public static async login(
        data: IDynamicObject<any>
    ): Promise<{ model: AccessModel; token: string }> {
        const request = await axios
            .getInstance()
            .post<IDynamicObject<any>>(`/api/admins/login`, data);
        return { model: new AccessModel(request.data), token: request.headers.authorization };
    }

    public static async logout(): Promise<void> {
        return await axios.getInstance().delete<void, void>(`/api/admins/logout`);
    }
}
